import { concat } from '../data/concat.js';
import { stringToBytes } from '../encoding/toBytes.js';
import { bytesToHex } from '../encoding/toHex.js';
import { keccak256 } from '../hash/keccak256.js';
export function namehash(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name)
        return bytesToHex(result);
    const labels = name.split('.');
    for (let i = labels.length - 1; i >= 0; i -= 1) {
        const hashed = keccak256(stringToBytes(labels[i]), 'bytes');
        result = keccak256(concat([result, hashed]), 'bytes');
    }
    return bytesToHex(result);
}
//# sourceMappingURL=namehash.js.map